
export const getSpaDeviceInfo = () => {
  return {
    deviceTypeId: 'A3OEMT9S4WNMK',
    deviceId: 'DUMMY-WIN10-DEVICE-ID', // TODO(PVWinApp-594): get DeviceId
  }
}

